<template>

    <div class="wrap-alarm">
        <alarm-list-link :listLayout="listLayout" :alarmData="List" v-if="List.length> 0"></alarm-list-link>
        <alarm-empty-link :empty-layout="emptyLayout" v-else></alarm-empty-link>
    </div>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
</template>
<script>
import AlarmListLink from "@/components/alarm/link/AlarmListLink.vue";
import PaginationLink from "@/components/alarm/link/PaginationLink.vue";
import AlarmEmptyLink from "@/components/alarm/link/AlarmEmptyLink.vue";
import alertMixin from "@/mixins/alertMixins.js";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import alarmUtil from "@/components/alarm/alarmUtil.js";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import {mapState, mapGetters} from "vuex";
import {ElMessage} from 'element-plus'

const {filterConfig} = alarmUtil;
let params = {};
export default {
    name: 'AlarmListComponent',
    mixins: [filterMixins, listMixins, alertMixin, alarmUtil,],
    components: {AlarmEmptyLink, AlarmListLink, PaginationLink},
    provide() {
        return {
            //readAlarm: this.readAlarm,
            alarmSetPage: this.setPage,
            alarmSetData: this.setData,
            deleteAlarmAlert: this.deleteAlarmAlert,

        }
    },
    props: {
        alarmType: {
            type: String,
            default: '',
        },
        changeAllDeleteButton: {
            default: () => {
            }, type: Function
        },
    },
    data() {
        return {
            listLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},
            pageRow: 20,
            selAlarms: [],
            emptyLayout: '',
            deleteList: [],
            loadingMore: false,
            removeLoading: true,
        }
    },
    created() {
        this.setParserType('url', '');
        this.setFilterConfig(filterConfig);
        this.initConfig();
        this.readAlarm();
    },
    mounted() {
        EventBus.$on('alarmAllDelete', this.deleteAlarmAlert);
        this.getList(true);
    },
    beforeUnmount() {
        EventBus.$off('alarmAllDelete');
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        initConfig() {
            let config = this.returnAlarmConfig(this.alarmType)
            this.listLayout = config.listLayout;
            this.emptyLayout = config.emptyLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.paginationType = config.paginationType;
            let listOptions = {
                url: this.$api.$alarm[this.getFunc],
                defaultParams: this.listApiParamSet
            };
            //listOptions.defaultParams.cid = this.UserInfo.ms_language;
            if (this.pageRow != 10) {
                this.setPage('size', this.pageRow);
            }
            this.initList('newJava', listOptions);
        },
        setData(key, value) {
            this[key] = value;
        },
        readAlarm() {
            params = {
                type: 'multi',
            };
            this.$api.$alarm.readAlarm(params).then(res => {
                if (res.code == 1) {
                    // let updateUserInfo = this.UserInfo;
                    // updateUserInfo.hasAlarm = false
                    // this.$store.dispatch('userInfo/changeUserInfo', {data: updateUserInfo});
                } else {
                }
            });
        },
        deleteAlarmAlert(data) {
            params = {
                title: "알림 삭제",
                content: "선택하신 알림을 삭제하겠습니까?",
                confirm: () => {
                    this.deleteAlarm(data);
                }
            };
            this.createConfirm(params);
        },
        deleteAlarm(data) {
            params = {
                ahIdx: [data]
            }
            this.$api.$alarm.deleteAlarm(params).then(res => {
                if (res.code === 1) {
                    this.getList(true);
                    ElMessage('알림이 삭제되었습니다.')
                } else {
                    // this.errorAlert("알림 삭제에 실패하였습니다.");
                    ElMessage('알림 삭제에 실패하였습니다.')
                }
            })
        },
        lazyLoadComplete($event) {
            if (!this.finishGetList) {
                setTimeout(() => {
                    this.lazyLoadComplete($event);
                }, 500)
                return false;
            }
            $event.loaded();
            this.loadingMore = false;
        },
        getList(isFirst = false) {
            this.finishGetList = false;
            if (isFirst) {
                EventBus.$emit('apiLoading', true);
                EventBus.$emit('apiLoadingShow', false)
            }
            try {

                let filterSet = JSON.parse(JSON.stringify(this.getFilterSet()));
                if (isFirst && this.paginationType === 'lazyload' && this.parserType === 'url') {
                    filterSet.page.page = 1;
                    this.filterSet.page.page = 1;
                    this.List = [];
                    if (!util.isEmpty(this.$route.query.page) && this.$route.query.page != 1) {
                        let url = this.$route.fullPath;
                        url = url.replace(`page=${this.$route.query.page}`, 'page=1');
                        this.$router.replace(url);
                    }
                    this.setPage('page', 1)
                } else if (isFirst && this.paginationType != 'lazyload') {
                    let parsingDataPage = this.getPasingDataPage();
                    filterSet.page.page = parsingDataPage;
                    this.List = [];
                }

                if (this.listClass === null) {
                    return false;
                }
                if (this.isInitPage === true && !this.isGetFirst && util.isEmpty(filterSet.filter)) {
                    this.List = [];
                    EventBus.$emit('apiLoading', false);
                    EventBus.$emit('apiLoadingShow', true)
                    return false;
                }
                this.listClass.getList(filterSet, this.isInitPage).then(res => {
                    let list = res.list.slice();
                    if (this.paginationType === 'lazyload' && filterSet.page.page > 1) {
                        this.List = this.List.concat(list);
                    } else {
                        this.List = list;
                    }
                    if (list.length === 0) {
                        this.removeLoading = true;
                    } else {
                        this.removeLoading = false;
                    }
                    if (res.hasOwnProperty('total')) {
                        this.setPage('total', res.total);
                    }
                    if (isFirst && this.paginationType === 'lazyload') {

                    } else if (isFirst) {
                        this.setParsingDataPageFilterSet();
                    }
                    if (this.isInitPage) {
                        this.setPage('page', 1);
                        this.isInitPage = false;
                    }
                    this.finishGetList = true;
                    if (!this.isGet) {
                        this.isGet = true;
                    }
                    EventBus.$emit('apiLoading', false);
                    EventBus.$emit('apiLoadingShow', true)
                })
            } catch (e) {
                console.log(e);
            }
        },
    },
    watch: {
        'List': {
            deep: true,
            handler: function (val, oldVal) {
                if (this.List.length === 0) {
                    this.changeAllDeleteButton(false);
                } else {
                    this.changeAllDeleteButton(true);
                }
            }
        }
    },
}
</script>
